import { all, call, put, select, takeLatest } from "redux-saga/effects";
import { CREATE_SDK_CONFIG, createSdkCofigSuccess } from "../actions/sdkConfig";

import { getSdkConfiguration } from "../../api/apiClient";
import { log } from "../../utils/loggger";
import { getAuthorizationHeader } from "../selectors/appConfig";
import { getwtmSessionDetails } from "../selectors/webToMobile";

export function* createSdkConfigSaga() {
  try {
    const headers = yield select(getAuthorizationHeader);
    const {
      sessionData: { webMobileRefId }
    } = yield select(getwtmSessionDetails);

    const response = yield call(getSdkConfiguration.get, headers, webMobileRefId);
    yield put(createSdkCofigSuccess(response));
  } catch (error) {
    log(error);
  }
}

export default function* sdkConfigSaga() {
  yield all([takeLatest(CREATE_SDK_CONFIG, createSdkConfigSaga)]);
}
